import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import { 
    TextValidatorNumber,
    TextValidatorNumberRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'


export const IdadeClienteDisabled = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="idadeCliente"
            label={LABEL.idade}
            value={values.idadeCliente === 0 ? 0 : values.idadeCliente || ''}
            onChange={handleChange}
            numMin={NUMMIN.idadeNascimento}
            numMax={NUMMAX.idade}
            disabled={true}
        />
    )
}

export const IdadeDataSimulacaoCliente = ({ values, handleChange }) => {

    return (
        <TextValidatorNumber
            name="idadeDataSimulacaoCliente"
            label={LABEL.idadeDataSimulacao}
            value={values.idadeDataSimulacaoCliente === 0 ? 0 : values.idadeDataSimulacaoCliente || ''}
            onChange={handleChange}
            numMin={NUMMIN.idadeNascimento}
            numMax={NUMMAX.idade}
            disabled={true}
        />
    )
}

export const IdadeVaiAposentarCliente = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="idadeVaiAposentarCliente"
            label={LABEL.idadeVaiAposentar}
            value={values.idadeVaiAposentarCliente === 0 ? 0 : values.idadeVaiAposentarCliente || ''}
            onChange={handleChange}
            numMin={NUMMIN.idade}
            numMax={NUMMAX.idade}
            disabled={!values.alterarIdadesAutomaticasCliente || (!dadosCompletosCliente(values) && dadosCompletosConjuge(values))}
        />
    )
}

export const IdadeInicioInssCliente = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="idadeInicioInssCliente"
            label={LABEL.idadeInicioInss}
            value={values.idadeInicioInssCliente === 0 ? 0 : values.idadeInicioInssCliente || ''}
            onChange={handleChange}
            numMin={NUMMIN.idade}
            numMax={NUMMAX.idade}
            disabled={!values.alterarIdadesAutomaticasCliente}
        />
    )
}

export const IdadeExpectativaVidaCliente = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="idadeExpectativaVidaCliente"
            label={LABEL.idadeExpectativaVida}
            value={values.idadeExpectativaVidaCliente === 0 ? 0 : values.idadeExpectativaVidaCliente || ''}
            onChange={handleChange}
            numMin={NUMMIN.idade}
            numMax={NUMMAX.idade}
            disabled={!values.alterarIdadesAutomaticasCliente}
        />
    )
}

export const IdadeSimulacaoMorteCliente = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="idadeSimulacaoMorteCliente"
            label={LABEL.idadeSimulacaoMorte}
            value={values.idadeSimulacaoMorteCliente === 0 ? 0 : values.idadeSimulacaoMorteCliente || ''}
            onChange={handleChange}
            numMin={NUMMIN.idade}
            numMax={NUMMAX.idade}
            disabled={!values.alterarIdadesAutomaticasCliente}
        />
    )
}

export const AlterarIdadesAutomaticasCliente = ({ values, handleChange }) => {

    return (
        <CheckboxPadrao
            name="alterarIdadesAutomaticasCliente"
            label={LABEL.alterarIdadesAutomaticas}
            checked={values.alterarIdadesAutomaticasCliente}
            onChange={handleChange}
        />
    )
}

export const IdadeConjuge = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="idadeConjuge"
            label={LABEL.idade}
            value={values.idadeConjuge === 0 ? 0 : values.idadeConjuge || ''}
            onChange={handleChange}
            numMin={NUMMIN.idadeNascimento}
            numMax={NUMMAX.idade}
            disabled={true}
        />
    )
}
                                    
export const IdadeDataSimulacaoConjuge = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="idadeDataSimulacaoConjuge"
            label={LABEL.idadeDataSimulacao}
            value={values.idadeDataSimulacaoConjuge === 0 ? 0 : values.idadeDataSimulacaoConjuge || ''}
            onChange={handleChange}
            numMin={NUMMIN.idadeNascimento}
            numMax={NUMMAX.idade}
            disabled={true}
        />
    )
}

export const IdadeVaiAposentarConjuge = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="idadeVaiAposentarConjuge"
            label={LABEL.idadeVaiAposentar}
            value={values.idadeVaiAposentarConjuge === 0 ? 0 : values.idadeVaiAposentarConjuge || ''}
            onChange={handleChange}
            numMin={NUMMIN.idade}
            numMax={NUMMAX.idade}
            disabled={!values.alterarIdadesAutomaticasConjuge}
        />
    )
}

export const IdadeExpectativaVidaConjuge = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="idadeExpectativaVidaConjuge"
            label={LABEL.idadeExpectativaVida}
            value={values.idadeExpectativaVidaConjuge === 0 ? 0 : values.idadeExpectativaVidaConjuge || ''}
            onChange={handleChange}
            numMin={NUMMIN.idade}
            numMax={NUMMAX.idade}
            disabled={!values.alterarIdadesAutomaticasConjuge}
        />
    )
}

export const AlterarIdadesAutomaticasConjuge = ({ values, handleChange }) => {

    return (
        <CheckboxPadrao
            name="alterarIdadesAutomaticasConjuge"
            label={LABEL.alterarIdadesAutomaticas}
            checked={values.alterarIdadesAutomaticasConjuge}
            onChange={handleChange}
        />
    )
}